// extracted by mini-css-extract-plugin
export default {"mainCard":"TotalAppoinmentCard_mainCard__Unwlx","textTotal":"TotalAppoinmentCard_textTotal__y6rR2","textCount":"TotalAppoinmentCard_textCount__B3zlq"};